import { matchPath } from 'react-router-dom';
import { IBreadcrumbItem } from 'dash-ui';

import { RoutesPath } from 'flow-components/routes/routes';
import { useGetSaleTeamByIdLazyQuery } from 'gql/generated.graphql';
import {
  IBreadcrumbScopeBuildHookParams,
  IBreadcrumbScopeBuildParams,
} from 'common/hooks/use-breadcrumb-builder/breadcrumbs-scope-builders/';

export const useSaleTeamBreadcrumbBuilder = (): [
  IBreadcrumbScopeBuildHookParams
] => {
  const [getSaleTeamById] = useGetSaleTeamByIdLazyQuery();

  return [
    async ({ pathname, t }: IBreadcrumbScopeBuildParams) => {
      const items: IBreadcrumbItem[] = [];

      const saleTeamParams = matchPath(RoutesPath.ExternalSalesUsers, pathname);

      items.push({
        label: t`externalSales`,
        path: RoutesPath.ExternalSales,
        icon: 'chart',
      });

      const saleTeamId = saleTeamParams?.params?.id;

      if (saleTeamId) {
        const saleTeamPath = RoutesPath.ExternalSalesUsers.replace(
          ':id',
          saleTeamId
        );
        const { data } = await getSaleTeamById({
          variables: { saleTeamId },
        });
        const { name } = data?.getSaleTeamById || {};

        if (name) {
          items.push({ label: name, path: saleTeamPath });
        }
      }

      return items;
    },
  ];
};
